<template>
    <div id="app">
        <container></container>
    </div>
</template>

<script>
import container from "./views/Container"

export default {
    components: { container },
    data() {
        return {}
    },
    mounted() {
        this.$router.afterEach((to, from) => {
            this.$nextTick(() => {
                // document.querySelector("#content-conatiner").scrollTo({top: 0, behavior: 'smooth'})
            })
        })
        this.$store.dispatch("listJourneys")
        this.$store.dispatch("listContents")
        this.$store.dispatch("listCategories")
        this.$store.dispatch("listCountries")
    }
}
</script>

<style>
</style>
